import { render, staticRenderFns } from "./yajin_list.vue?vue&type=template&id=88c1708a&scoped=true&"
import script from "./yajin_list.vue?vue&type=script&lang=js&"
export * from "./yajin_list.vue?vue&type=script&lang=js&"
import style0 from "./yajin_list.vue?vue&type=style&index=0&id=88c1708a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c1708a",
  null
  
)

export default component.exports